import type { IconProps } from '@/components/CustomIcon/types';

export const AcademicCalendarIcon = ({
  size = 20,
  className,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15.8333 15.8333H4.16667V6.66658H15.8333M13.3333 0.833252V2.49992H6.66667V0.833252H5V2.49992H4.16667C3.25 2.49992 2.5 3.24992 2.5 4.16659V15.8333C2.5 16.2753 2.67559 16.6992 2.98816 17.0118C3.30072 17.3243 3.72464 17.4999 4.16667 17.4999H15.8333C16.7583 17.4999 17.5 16.7583 17.5 15.8333V4.16659C17.5 3.72456 17.3244 3.30063 17.0118 2.98807C16.6993 2.67551 16.2754 2.49992 15.8333 2.49992H15V0.833252M9.06667 9.99992H6.05833L8.49167 11.7583L7.56667 14.6333L10 12.8583L12.4333 14.6333L11.5 11.7666L13.9333 9.99992H10.9333L10 7.13325L9.06667 9.99992Z"
        fill="currentColor"
      />
    </svg>
  );
};
